<div
  [id]="elementId"
  class="barcode-scanner-viewport"
  [hidden]="cameraState === 'blocked' || cameraState === 'unavailable'"
></div>

@if (cameraState === 'blocked') {
  <div class="camera-message" role="alert">
    <mat-icon class="camera-message__icon" fontSet="material-icons-outlined"
      >no_photography</mat-icon
    >
    <h3 class="camera-message__title">
      {{ 'camera_access_required_title' | translate }}
    </h3>
    <p class="camera-message__text">
      {{ 'camera_access_required_message' | translate }}
    </p>
    <p class="camera-message__hint">
      {{ 'camera_access_blocked_hint' | translate }}
    </p>
    @if (canRequestPermission) {
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="enableCamera()"
      >
        <span class="btn-content">
          <mat-icon fontSet="material-icons-outlined">photo_camera</mat-icon>
          {{ 'Enable Camera' | translate }}
        </span>
      </button>
    }
  </div>
}

@if (cameraState === 'unavailable') {
  <div class="camera-message" role="alert">
    <mat-icon class="camera-message__icon" fontSet="material-icons-outlined"
      >no_photography</mat-icon
    >
    <h3 class="camera-message__title">
      {{ 'Camera unavailable' | translate }}
    </h3>
    <p class="camera-message__text">
      {{ 'camera_unavailable_message' | translate }}
    </p>
  </div>
}
